// components/focusMode/FocusToggle.jsx
export default function FocusToggle({
  focusMode,
  toggleFocus,
  disabled = false,
  labelOn = "Focus Mode",
  labelOff = "Focus Mode",
}) {
  return (
    <label className="suggestion-toggle">
      <input
        type="checkbox"
        checked={!!focusMode}
        disabled={disabled}
        onChange={() => toggleFocus()}
      />
      <span className="toggle-slider"></span>
      <span className="toggle-label">{focusMode ? labelOn : labelOff}</span>
    </label>
  );
}